// extracted by mini-css-extract-plugin
export default {"letterBar":"letterBar--ggrB1"};